interface Props {
  label: string;
  isActive: boolean;
  index: number;
}
export default function Step({ label, isActive, index }: Props) {
  return (
    <div className="flex items-end gap-3">
      <div className=" flex lg:flex-col items-center">
        <div
          className={`w-[20px] h-[2px] lg:h-[30px] lg:w-[2px] ${
            isActive ? "bg-blue-500" : "bg-[#6E7183]"
          } ${index === 1 ? "hidden" : "block"} `}
        ></div>
        <span
          className={`flex justify-center items-center w-[40px] h-[40px] text-xs text-onPrimary rounded-full ${
            isActive ? "bg-blue-500" : "bg-[#6E7183]"
          } `}
        >
          {index}
        </span>
      </div>
      <div className="hidden lg:flex flex-col gap-2">
        <span className=" font-body font-medium text-body">Stap {index}</span>
        <p
          className={` text-base font-normal font-body ${
            isActive ? " text-primary" : "text-[#6E7183]"
          }`}
        >
          {label}
        </p>
      </div>
    </div>
  );
}
